<app-material>
    <ng-container body>
        <img class="logo-image-mobile"
             src="../../../../assets/images/atom_v1_logo.png"
             *ngIf="this.isMobile">
        <img class="logo-image"
             *ngIf="!this.isMobile">
        <img class="overlay"
             src="../../../../assets/images/atom.png">
    </ng-container>
</app-material>
